import { defineStore } from "pinia";

export const useTrainingRequestStore = defineStore('trainingRequest', {
    state: () => ({
        trainingRequest: {},
        trainingRequests: [],
    }),
    actions: {
        setTrainingRequest(trainingRequest) {
            this.trainingRequest = trainingRequest
        },
        setTrainingRequests(trainingRequests) {
            this.trainingRequests = trainingRequests
        },
        addTrainingRequest(trainingRequest) {
            this.trainingRequests.unshift(trainingRequest)
        },
        updateTrainingRequest(trainingRequest) {
            let index = this.trainingRequests.findIndex(cl => cl.id === trainingRequest.id)
            this.trainingRequests.splice(index, 1, trainingRequest)
        },
        deleteTrainingRequest(trainingRequest) {
            let index = this.trainingRequests.findIndex(cl => cl.id === trainingRequest.id)
            this.trainingRequests.splice(index, 1)
        },
    },
});